import BotSettings from './_Bot';
import GeneralSettings from './_General';
import FeedbackSettings from './_Feedback';
import DynamicMessageSettings from './_DynamicMessageSettings';

export default {
  blocks: [
    GeneralSettings,
    BotSettings,
    FeedbackSettings,
    DynamicMessageSettings,
  ],
};
